import { render, staticRenderFns } from "./ResultPollAverage.vue?vue&type=template&id=f60207a0&"
import script from "./ResultPollAverage.vue?vue&type=script&lang=js&"
export * from "./ResultPollAverage.vue?vue&type=script&lang=js&"
import style0 from "./ResultPollAverage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports